<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col>
                <strong style="font-size: 25px">Business Performance: {{ title }}</strong>
            </a-col>
        </a-row>

        <common-training-header />

        <a-row type="flex" style="margin-bottom: 12px;margin-top: 12px">
            <a-col>
                <strong style="font-size: 25px">Pencapaian Kinerja Bulanan</strong>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <div slot="extra" style="text-align: right">
                Perspektif
                <a-select style="width: 150px" @change="handleChange">
                    <a-select-option
                        value="financial">
                        Financial
                    </a-select-option>
                    <a-select-option
                        value="customer">
                        Customer Focus
                    </a-select-option>
                    <a-select-option
                        value="business">
                        Business Internal
                    </a-select-option>
                    <a-select-option
                        value="learning">
                        Learning & Growth
                    </a-select-option>
                </a-select>

                Bulan
                <a-select style="width: 150px" @change="handleMonthChange">
                    <a-select-option
                        value="Januari">
                        Januari
                    </a-select-option>
                    <a-select-option
                        value="Februari">
                        Februari
                    </a-select-option>
                    <a-select-option
                        value="Maret">
                        Maret
                    </a-select-option>
                    <a-select-option
                        value="April">
                        April
                    </a-select-option>
                    <a-select-option
                        value="Mei">
                        Mei
                    </a-select-option>
                    <a-select-option
                        value="Juni">
                        Juni
                    </a-select-option>
                    <a-select-option
                        value="Juli">
                        Juli
                    </a-select-option>
                    <a-select-option
                        value="Agustus">
                        Agustus
                    </a-select-option>
                    <a-select-option
                        value="September">
                        September
                    </a-select-option>
                    <a-select-option
                        value="Oktober">
                        Oktober
                    </a-select-option>
                    <a-select-option
                        value="November">
                        November
                    </a-select-option>
                    <a-select-option
                        value="Desember">
                        Desember
                    </a-select-option>
                </a-select>

                Tahun
                <a-select style="width: 150px" @change="handleYearChange">
                    <a-select-option
                        value="2020">
                        2020
                    </a-select-option>
                    <a-select-option
                        value="2021">
                        2021
                    </a-select-option>
                    <a-select-option
                        value="2022">
                        2022
                    </a-select-option>
                </a-select>

                <a-button type="primary">View</a-button>
            </div>
            
            <a-table :columns="columns" :dataSource="tableData" rowKey="id" :pagination="false" :loading="loading" bordered>

                <div slot="name" slot-scope="r" style="text-align: left;">
                    <p>
                        <small v-if="r.is_heading"><strong>{{ r.name}}</strong></small>
                        <small v-else>{{ r.name}}</small>
                    </p>
                </div>
                <div style="text-align: center;" slot="weight" slot-scope="r" v-show="! r.is_heading">
                    <strong>{{ r.weight}}</strong>
                </div>
                <div slot="target_assignment" slot-scope="r" v-show="! r.is_heading" style="text-align: left;">
                    <small>{{ r.description }}</small>
                </div>
                <div style="text-align: center;" slot="target_proporsional" slot-scope="r" v-show="! r.is_heading">
                    <small>{{ r.proporsional }}</small>
                </div>
                <div style="text-align: center;" slot="realisasi" slot-scope="r" v-show="! r.is_heading">
                    <small>{{ r.realisasi }}</small>
                </div>
                <div style="text-align: center;" slot="pencapaian" slot-scope="r" v-show="! r.is_heading">
                    <small>{{ r.assignment }} </small>
                </div>
                <div style="text-align: center;" slot="pencapaian_target" slot-scope="r" v-show="! r.is_heading">
                    <small>{{ r.target_lap }}</small>
                </div>
                <div style="text-align: center;" slot="nilai_predikat" slot-scope="r" v-show="! r.is_heading">
                    <small>{{ r.score }}</small>
                </div>
                <div style="text-align: center;" slot="wom" slot-scope="r" v-show="! r.is_heading"><a-tag :color="r.wom">WOM</a-tag> </div>
                <div style="text-align: center;" slot="file" slot-scope="r" v-show="! r.is_heading">
                    <a-button type="dashed" icon="download"/>
                </div>
                <div style="text-align: center;" slot="evaluasi" slot-scope="r" v-show="! r.is_heading"></div>
                <div style="text-align: center;" slot="action" slot-scope="r" v-show="! r.is_heading">
                    <a-button v-if="! verified.includes(r.id)" type="primary" icon="safety" @click="() => verified.push(r.id)">Verify</a-button>
                    <a-button v-else icon="check"> Verified</a-button>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
        key: 'name',
        title: 'Business Internal',
        align: 'center',
        scopedSlots: { customRender: 'name' },
    },
    {
        key: 'weight',
        title: 'Bobot',
        align: 'center',
        scopedSlots: { customRender: 'weight' },
    },
    {
        key: 'target_assignment',
        title: 'Target Selama Project Assignment',
        align: 'center',
        scopedSlots: { customRender: 'target_assignment' },
    },
    {
        key: 'target_proporsional',
        title: 'Target Proporsional Sd Bln Lap',
        align: 'center',
        scopedSlots: { customRender: 'target_proporsional' },
    },
    {
        key: 'realisasi',
        title: 'Realisasi Sd Bln Lap',
        align: 'center',
        scopedSlots: { customRender: 'realisasi' },
    },
    {
        key: 'pencapaian',
        title: 'Pencapaian Thd Target Project Assignment',
        align: 'center',
        scopedSlots: { customRender: 'pencapaian' },
    },
    {
        key: 'pencapaian_target',
        title: 'Pencapaian Target SD Bln Lap',
        align: 'center',
        scopedSlots: { customRender: 'pencapaian_target' },
    },
    {
        key: 'nilai_predikat',
        title: 'Nilai Predikat Pencapaian Sasaran',
        align: 'center',
        scopedSlots: { customRender: 'nilai_predikat' },
    },
    {
        key: 'wom',
        title: 'WOM',
        align: 'center',
        scopedSlots: { customRender: 'wom' },
    },
    {
        key: 'file',
        title: 'File',
        align: 'center',
        scopedSlots: { customRender: 'file' },
    },
    {
        key: 'evaluasi',
        title: 'Evaluasi Pembimbing',
        align: 'center',
        scopedSlots: { customRender: 'evaluasi' },
    },
    {
        key: 'action',
        title: '',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'action' },
    },
    ]

    export default {
        props: {
            type: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                columns,
                month: '-',
                year: '-',
                perspektif: '-',
                verified: [],
                    customer: [],
                business: [],
                learning: [],
                financial: [
                    {
                        id: 1,
                        name: 'LENDING',
                        weight: '',
                        description: '',
                        proporsional: '',
                        realisasi: '',
                        assignment: '',
                        target_lap: '',
                        score: '',
                        wom: '',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: true
                    },
                    {
                        id: 2,
                        name: 'Penyelesaian Kredit Gol 3,4, dan 5',
                        weight: '3%',
                        description: 'Tercapai target penyelesaian kredit Gol 3,4,5 Rp. 30.000.000',
                        proporsional: '15.000.000',
                        realisasi: '25.450.000',
                        assignment: '84.83 %',
                        target_lap: '169.6 %',
                        score: '5',
                        wom: 'green',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 3,
                        name: 'Pemasaran Kredit UMKM, Program & Multiguna',
                        weight: '7%',
                        description: 'Tercapai Target Pemasaran Kredit UMKM, Program & Multiguna Rp. 840.000.000',
                        proporsional: '700.000.000',
                        realisasi: '740.000.000',
                        assignment: '88.1 %',
                        target_lap: '105.7 %',
                        score: '4',
                        wom: 'blue',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 4,
                        name: 'FUNDING',
                        weight: '',
                        description: '',
                        proporsional: '',
                        realisasi: '',
                        assignment: '',
                        target_lap: '',
                        score: '',
                        wom: '',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: true
                    },
                    {
                        id: 5,
                        name: 'Penghimpunan Dana Giro Swasta',
                        weight: '2%',
                        description: 'Tercapai Target Pemasaran Giro Swasta Rp. 99.000.000',
                        proporsional: '82.500.000',
                        realisasi: '38.600.000',
                        assignment: '38.99 %',
                        target_lap: '46.79 %',
                        score: '1',
                        wom: 'red',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 6,
                        name: 'Penghimpunan Dana Deposito Swasta',
                        weight: '3%',
                        description: 'Tercapai Target Pemasaran Deposito Swasta Rp. 231.000.000',
                        proporsional: '192.500.000',
                        realisasi: '400.000.000',
                        assignment: '173.16 %',
                        target_lap: '207.7 %',
                        score: '5',
                        wom: 'green',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 7,
                        name: 'Penghimpunan Dana Tabungan',
                        weight: '10%',
                        description: 'Tercapai Target Pemasaran Tabungan Rp. 330.000.000',
                        proporsional: '275.000.000',
                        realisasi: '659.655.075',
                        assignment: '199.9 %',
                        target_lap: '239.8 %',
                        score: '5',
                        wom: 'green',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 8,
                        name: 'SALES ACTIVITY FUNDING',
                        weight: '',
                        description: '',
                        proporsional: '',
                        realisasi: '',
                        assignment: '',
                        target_lap: '',
                        score: '',
                        wom: '',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: true
                    },
                    {
                        id: 9,
                        name: 'Sales Activity (Contact, Make Appoitnment, Need Analysis, Presentation, Closing, Service selling, Reference)',
                        weight: '15%',
                        description: 'Tercapai Target Score Sales Activity Funding Rp. 6.538 Point',
                        proporsional: '5.448 Point',
                        realisasi: '7.338 Point',
                        assignment: '112.24 %',
                        target_lap: '178.5 %',
                        score: '5',
                        wom: 'green',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 10,
                        name: 'Funding Presentation Activity',
                        weight: '5%',
                        description: 'Tercapai Target Jumlah Presentasi Penjualan Funding Rp. 1.440',
                        proporsional: '1.200',
                        realisasi: '2.142',
                        assignment: '148.75 %',
                        target_lap: '134.6 %',
                        score: '5',
                        wom: 'green',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 11,
                        name: 'Marketing Activity DG Bankaltimtara  ',
                        weight: '30%',
                        description: 'Tercapai Target Jumlah Marketing Activity DG Bankaltimtara 864 Point',
                        proporsional: '0 Point',
                        realisasi: '',
                        assignment: '',
                        target_lap: '',
                        score: '',
                        wom: '',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 12,
                        name: 'SALES ACTIVITY LENDING',
                        weight: '',
                        description: '',
                        proporsional: '',
                        realisasi: '',
                        assignment: '',
                        target_lap: '',
                        score: '',
                        wom: '',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: true
                    },
                    {
                        id: 13,
                        name: 'Lending Sales Activity (Contact, Make Appoitnment, Need Analysis, Presentation, Closing, Service selling, Reference)',
                        weight: '10%',
                        description: 'Tercapai Target Score Sales Activity Lending 645 Point',
                        proporsional: '538 Point',
                        realisasi: '475 Point',
                        assignment: '73.64 %',
                        target_lap: '88.29 %',
                        score: '2',
                        wom: 'orange',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 14,
                        name: 'Lending Presentation Activity',
                        weight: '5%',
                        description: 'Tercapai Target Jumlah Presentasi Penjualan Lending 126 Point',
                        proporsional: '105 Point',
                        realisasi: '162 Point',
                        assignment: '128.57 %',
                        target_lap: '154.2 %',
                        score: '5',
                        wom: 'green',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                    {
                        id: 15,
                        name: 'Lending Collecting Activity (Kred Gol 3,4 dan 5)',
                        weight: '10%',
                        description: 'Tercapai Score Lending Collecting Activity (Gol 3,4 dan 5) 1.171 Point',
                        proporsional: '586 Point',
                        realisasi: '351 Point',
                        assignment: '29.97 %',
                        target_lap: '59.90 %',
                        score: '1',
                        wom: 'red',
                        file: '',
                        evaluasi: '',
                        action: '',
                        is_heading: false
                    },
                ],
                
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems() {
                this.loading = true;

                let params = this.activeModule.module.identifier == 'paper' ? null : {
                    params: {
                        outline: this.outline
                    }
                }

                this.$http
                    .get(this.routeUri("api.activity-notulens.attendants"), params)
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            handleChange(value) {
                this.perspektif = value
            },
            handleMonthChange(value) {
                this.month = value
            },
            handleYearChange(value) {
                this.year = value
            },
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            },
            tableData() {
                return this.perspektif === '-' ? [] : this[this.perspektif]
            },
        }
    }
</script>